import { render, staticRenderFns } from "./userInvest.vue?vue&type=template&id=00047016&scoped=true"
import script from "./userInvest.vue?vue&type=script&lang=js"
export * from "./userInvest.vue?vue&type=script&lang=js"
import style0 from "./userInvest.vue?vue&type=style&index=0&id=00047016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00047016",
  null
  
)

export default component.exports